// @spec DHB-STR-048
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ScheduledExportsPage } from '@/features/datahub/exports';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/datahub/governance/scheduled-exports')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.scheduledExports'),
  }),
  component: ScheduledExportsPage,
});
